import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { T } from "react-translator-component";
import { Modal, Box, Typography } from "@mui/material";
import { colors } from "../../common/colors";
import SubmitButton from "../SubmitButton";

interface OptionsModalProps {
  open: boolean;
  onClose: () => void;
  onSelect: (optionValue: string) => void;
}

interface Option {
  name: string;
  value: string;
  disabled: boolean;
}

const NameOptionModal: React.FC<OptionsModalProps> = ({ open, onClose, onSelect }) => {
  const NAME_OPTIONS: Option[] = [
    { name: T("nickname"), value: "1", disabled: false },
    { name: T("real_name"), value: "2", disabled: false },
    { name: T("anonymous"), value: "3", disabled: false },
  ];

  const { user } = useSelector((state: any) => state.userAuth);
  const [nameOptions, setNameOptions] = useState<Option[]>([])

  useEffect(() => {
    if (user?.name) {
      setNameOptions(NAME_OPTIONS)
      return
    }

    setNameOptions(NAME_OPTIONS.map((option: Option) => {
      if (option.value === "2") option.disabled = true
      return option
    }))
  }, [])

  const handleOptionSelect = async (option: Option) => {
    if (option.disabled) return false

    try {
      onSelect(option.value);
      return true
    } catch {
      return false
    } finally {
      onClose();
    }
  };

  return (
    <Modal style={{ zIndex: 9999 }} open={open} onClose={onClose} aria-labelledby="modal-title" aria-describedby="modal-description">
      <Box sx={style}>
        <Typography style={{ fontSize: 18, fontWeight: "600" }} id="modal-title" variant="h6" component="h3">
          コメントに表示するお名前
        </Typography>
        <Typography
          style={{
            fontSize: 12,
            textAlign: "center",
            marginTop: 4,
            marginBottom: 4,
          }}
          component="p"
        >
          コメント欄に表示させるお名前を以下の3つから選んでください。
        </Typography>
        {nameOptions.map((option: Option) => (
          <SubmitButton
            sx={buttonStyle}
            disabled={option.disabled}
            size={"small"}
            validate={async () => true}
            onSubmit={() => handleOptionSelect(option)}
            key={`name_option_${option.value}`}
          >
            {option?.name}
          </SubmitButton>
        ))}
      </Box>
    </Modal>
  );
};

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

const buttonStyle = {
  margin: '2px',
  color: colors.farm_blue200,
  fontWeight: "600",
};

export default NameOptionModal;
